import { createContext } from 'react';
import type { RegistryContextValue } from './types';

export const RegistryContext = createContext<RegistryContextValue | null>(null);
